import React from "react";
import PropTypes from "prop-types";
import { Frame } from "@bitesite/react-figstrap";
import { Button } from "../../../odc-ui";
import {
  selectionButtonType,
  friendlyDefaultCadence,
} from "../common/utilities";

const SubscriptionPlanVariationSelection = ({
  subscriptionPlan,
  selectedSubscriptionPlanVariation,
  onSubscriptionPlanVariationClick,
  theme,
}) => {
  return (
    <Frame vertical gap={10}>
      <div>How frequently would you like to make payments?</div>

      <Frame vertical gap={10}>
        {subscriptionPlan.subscription_plan_variations.map(
          (subscriptionPlanVariation) => (
            <Button
              textTransform="none"
              type={selectionButtonType(
                theme,
                selectedSubscriptionPlanVariation &&
                  selectedSubscriptionPlanVariation.id ===
                    subscriptionPlanVariation.id
              )}
              key={subscriptionPlanVariation.id}
              onClick={() => {
                onSubscriptionPlanVariationClick(subscriptionPlanVariation);
              }}
            >
              {friendlyDefaultCadence(subscriptionPlanVariation)}
            </Button>
          )
        )}
      </Frame>
    </Frame>
  );
};

SubscriptionPlanVariationSelection.propTypes = {
  subscriptionPlan: PropTypes.object.isRequired,
  selectedSubscriptionPlanVariation: PropTypes.object,
  onSubscriptionPlanVariationClick: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
};

export default SubscriptionPlanVariationSelection;
